/* launch-offer.js — WS-URGENCY. Keeps every LAUNCH25 surface true. Liquid (snippets/launch-offer.liquid) renders the right state from the
   server clock; this file ticks it after load and flips it at the deadline. One source: <html data-lo-end/-dhm/-hms> (epoch seconds).
   Staging only: ?preview_time=<ISO|epoch> (stored for the tab session; ?preview_time=off clears) when <html data-lo-preview> is present
   (Liquid sets it only when theme.role is not 'main'). Never resets, never extends, no cookie/session start time. */
(function () {
  'use strict';
  var root = document.documentElement;
  if (!root.hasAttribute('data-lo-end')) return;
  var END = +root.getAttribute('data-lo-end'), DHM = +root.getAttribute('data-lo-dhm'), HMS = +root.getAttribute('data-lo-hms');
  var DATE = root.getAttribute('data-lo-date') || '';
  var offset = 0;
  if (root.hasAttribute('data-lo-preview')) {
    try {
      var q = new URLSearchParams(location.search).get('preview_time');
      if (q === 'off') sessionStorage.removeItem('lo-preview');
      else if (q) sessionStorage.setItem('lo-preview', q);
      var v = sessionStorage.getItem('lo-preview');
      if (v) {
        var t = /^\d{9,}$/.test(v) ? (+v) * 1000 : Date.parse(v);
        if (!isNaN(t)) offset = t - Date.now();
      }
    } catch (e) {}
  }
  var last = {};
  function put(sel, text) {
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) if (els[i].textContent !== text) els[i].textContent = text;
  }
  function tick() {
    var now = Math.floor((Date.now() + offset) / 1000), left = END - now, state;
    if (left <= 0) state = 'ended'; else if (now >= HMS) state = 'hms'; else if (now >= DHM) state = 'dhm'; else state = 'days';
    var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
    var body = state === 'days' ? (d === 1 ? '1 day' : d + ' days')
      : state === 'dhm' ? d + 'd ' + h + 'h ' + m + 'm'
      : state === 'hms' ? h + 'h ' + m + 'm ' + (s < 10 ? '0' : '') + s + 's' : '';
    if (root.getAttribute('data-lo') !== state) {
      /* U-12: the "now shipping" copy is not in the page before the deadline, so a visitor who crosses it reloads once to get it (live only; guarded against loops) */
      if (state === 'ended' && !root.hasAttribute('data-lo-preview')) {
        try { if (!sessionStorage.getItem('lo-ended-reload')) { sessionStorage.setItem('lo-ended-reload', '1'); location.reload(); return; } } catch (e) {}
      }
      root.setAttribute('data-lo', state);
      var links = document.querySelectorAll('[data-lo-href-live]');
      for (var i = 0; i < links.length; i++) links[i].setAttribute('href', links[i].getAttribute(state === 'ended' ? 'data-lo-href-ended' : 'data-lo-href-live'));
    }
    var key = state + body;
    if (last.key !== key) {
      last.key = key;
      put('[data-lo-count]', state === 'ended' ? 'LAUNCH25 has ended' : body + ' left');
      put('[data-lo-count-body]', body);
      put('[data-lo-chip-t]', state === 'dhm' || state === 'hms' ? 'ends in ' + body : 'ends ' + DATE);
    }
    if (state === 'ended') return;
    setTimeout(tick, state === 'hms' ? 1000 : 15000 - (Date.now() % 15000) + 5);
  }
  tick();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { last = {}; tick(); } });
  /* sections re-rendered later (cart drawer, theme editor) come from the server clock: re-sync */
  document.addEventListener('shopify:section:load', function () { last = {}; tick(); });
})();
